/* unplugin-vue-components disabled */import { render } from "./collapse.vue?vue&type=template&id=629fad5d&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=629fad5d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629fad5d"],['__file',"src/controls/collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "629fad5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('629fad5d', __exports__)) {
    api.reload('629fad5d', __exports__)
  }
  
  module.hot.accept("./collapse.vue?vue&type=template&id=629fad5d&scoped=true", () => {
    api.rerender('629fad5d', render)
  })

}


export default __exports__